import React from "react";
import {InfoWindow} from "react-google-maps";
import {PickupSiteTypes, GOOGLE_UNDEFINED_ERROR_MESSAGE} from "../../common/constants";
import {PATH_IMAGES} from "../../common/utils";
import {PickupSitesMap} from "../common/PickupSitesMap";
import {translate} from '../../i18n/translate.js';

class AccountMap extends React.Component {
    state = {
        center: {},
        marker: {}
    };

    componentWillMount() {
        const pickupSite = this.props.pickupSite;
        let lat;
        let lng;
        if (pickupSite.type === PickupSiteTypes.ZONE) {
            lat = pickupSite.privateLat;
            lng = pickupSite.privateLng;
        } else {
            lat = pickupSite.lat;
            lng = pickupSite.lng;
        }
        let position;
        try {
            position = new google.maps.LatLng(lat, lng);
        }
        catch(error) {
            this.props.errorFetching(GOOGLE_UNDEFINED_ERROR_MESSAGE);
            return;
        }
        const marker =  {
            position,
            showInfo: true,
            icon: PATH_IMAGES + "site-large.png",
            title: pickupSite.title,
            key: pickupSite.key,
            pickupSite: pickupSite
        };
        this.setState({marker: marker, center: marker.position});
    }

    //Toggle to 'true' to show InfoWindow and re-renders component
    handleMarkerClick = (marker) => {
        marker.showInfo = true;
        this.setState({marker: marker});
    };

    handleMarkerClose = (marker) => {
        marker.showInfo = false;
        this.setState({marker: marker});
    };

    renderInfoWindow = (index, marker) => {
        const pickupSite = marker.pickupSite;
        const deliveryDetails = pickupSite.deliveryDays + ', ' + pickupSite.deliveryHours;
        return (<InfoWindow key={pickupSite.key} onCloseClick={()=>this.handleMarkerClose(marker)}>
            <div className="account-pick-up-site-info-container">
                <div className="account-pick-up-site-map-info-title">
                    {pickupSite.title}
                </div>
                <div className="pick-up-site-info-address">
                    {pickupSite.shortAddress}
                </div>
                <div className="pick-up-site-info-day-hour">{deliveryDetails}</div>
            </div>
        </InfoWindow>);
    };

    render() {
        return(<PickupSitesMap containerElement={<div className="google-map-container"/>}
                               mapElement={<div style={{ height: "100%" }} />}
                               options={this.props.options}
                               center={this.state.center}
                               markers={[this.state.marker]}
                               zoom={14}
                               bounds={this.state.bounds}
                               handleMarkerClick={this.handleMarkerClick}
                               handleMarkerClose={this.handleMarkerClose}
                               renderInfoWindow={this.renderInfoWindow}
                               handleMapZoomChanged={() => {}}
                               handleMapCenterChanged={() => {}}
                               onMapMounted={() => {}}/>);
    }
}

export default AccountMap;


// WEBPACK FOOTER //
// ./src/components/account/AccountMap.js